import { render } from "./WhiteLabelIndex.vue?vue&type=template&id=4db1da53"
import script from "./WhiteLabelIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./WhiteLabelIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/white-label/components/WhiteLabelIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4db1da53"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4db1da53', __exports__)) {
    api.reload('4db1da53', __exports__)
  }
  
  module.hot.accept("./WhiteLabelIndex.vue?vue&type=template&id=4db1da53", () => {
    api.rerender('4db1da53', render)
  })

}


export default __exports__